import { configureChains, createConfig } from 'wagmi';
import { mainnet, hardhat } from 'wagmi/chains';
import { InjectedConnector } from 'wagmi/connectors/injected';
import { WalletConnectConnector } from 'wagmi/connectors/walletConnect';
import { CoinbaseWalletConnector } from 'wagmi/connectors/coinbaseWallet';
import { publicProvider } from 'wagmi/providers/public';
import { jsonRpcProvider } from 'wagmi/providers/jsonRpc';
import { createNetworkHttpUrl, CHAIN_ID } from './config';

// WalletConnect Project ID - get one at https://cloud.walletconnect.com
const WALLETCONNECT_PROJECT_ID = process.env.REACT_APP_WALLETCONNECT_PROJECT_ID || '';

// Configure chains based on environment
const chainConfig = CHAIN_ID === 1 ? mainnet : hardhat;

const { chains, publicClient, webSocketPublicClient } = configureChains(
  [chainConfig],
  [
    jsonRpcProvider({
      rpc: (chain) => {
        if (chain.id === 1) {
          return { http: createNetworkHttpUrl('mainnet') };
        }
        return { http: 'http://localhost:8545' };
      },
    }),
    publicProvider(),
  ],
);

type Connector = InjectedConnector | CoinbaseWalletConnector | WalletConnectConnector;

const connectors: Connector[] = [
  new InjectedConnector({
    chains,
    options: {
      name: 'Browser Wallet',
      shimDisconnect: true,
    },
  }),
  new CoinbaseWalletConnector({
    chains,
    options: {
      appName: 'Bitstrays',
    },
  }),
];

// Only add WalletConnect if project ID is configured
if (WALLETCONNECT_PROJECT_ID) {
  connectors.push(
    new WalletConnectConnector({
      chains,
      options: {
        projectId: WALLETCONNECT_PROJECT_ID,
        showQrModal: true,
        metadata: {
          name: 'Bitstrays',
          description: 'Bitstrays NFT Collection',
          url: 'https://bitstrays.com',
          icons: ['https://bitstrays.com/favicon.ico'],
        },
      },
    }),
  );
}

export const wagmiConfig = createConfig({
  autoConnect: true,
  connectors,
  publicClient,
  webSocketPublicClient,
});

export { chains, WALLETCONNECT_PROJECT_ID };
